import { useEffect, useRef } from "react";
import Webcam from "react-webcam";

/**
 * Convert base64 image to File
 */
function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export default function AutoCamera({ running, onFrame }) {
  const webcamRef = useRef(null);
  const videoReadyRef = useRef(false);

  // ✅ Prevent spamming
  const processingRef = useRef(false);

  useEffect(() => {
    if (!running) return;

    const interval = setInterval(async () => {
      if (!webcamRef.current || !videoReadyRef.current) return;

      // ❌ If already processing → skip
      if (processingRef.current) return;

      const img = webcamRef.current.getScreenshot();
      if (!img) return;

      processingRef.current = true;

      try {
        await onFrame(dataURLtoFile(img, "face.jpg"));
      } catch (e) {
        // ignore
      }

      // ✅ small delay after each attempt
      setTimeout(() => {
        processingRef.current = false;
      }, 2000); // 2 sec cooldown

    }, 1500);

    return () => clearInterval(interval);
  }, [running, onFrame]);

  return (
    <div className="relative w-full h-full rounded-2xl overflow-hidden bg-black">
      <Webcam
        ref={webcamRef}
        audio={false}
        screenshotFormat="image/jpeg"
        className="w-full h-full object-contain"
        onUserMedia={() => {
          videoReadyRef.current = true;
          console.log("✅ Camera ready");
        }}
        videoConstraints={{
          facingMode: "user",
          width: 640,
          height: 640,
        }}
      />
    </div>
  );
}